import { CSSProperties } from 'styled-components';

const mainContainer: CSSProperties = {
  textAlign: 'center',
  padding: '40px 20px',
  gridAutoRows: 'auto',
};
const gridItem: CSSProperties = {
  padding: '10px 0px',
};
const inlineBlock: CSSProperties = {
  display: 'inline-block',
  marginRight:'5px'
};
const button: CSSProperties = {
  minHeight: '40px',
  margin: '6px'
};
const icon: CSSProperties = {
  width: '60px',
  height: '60px',
};
const emailIcon: CSSProperties = {
  width: '70px',
  height: '70px',
};

export { mainContainer, gridItem, inlineBlock, button, icon, emailIcon };
